module.exports = __webpack_public_path__ + "static/img/MRT主界面.abff37c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_images/MRT主界面.jpg
// module id = b6bI
// module chunks = 1